import React from 'react';
import { SectionWrapper } from './ui/SectionWrapper';
import { CheckCircle2 } from 'lucide-react';
import { CTAButton } from './ui/CTAButton';
const deliverables = [{
  title: 'La Guía Digital Completa',
  description: 'El paso a paso detallado para tu reseteo de fin de semana.'
}, {
  title: 'Protocolo Sábado de Reseteo',
  description: 'Tu hoja de ruta exacta para vaciar líquidos desde el primer día.'
}, {
  title: 'Lista de Compra USA',
  description: 'Qué comprar exactamente en Walmart, Target o Costco para desinflamarte (y qué dejar en el estante).'
}, {
  title: 'Esquema de Micro-Ayunos 4-4-12',
  description: 'La regla de oro para mantener los resultados sin dejar de comer lo que te gusta.'
}, {
  title: 'Worksheets de Seguimiento',
  description: 'Herramientas para medir tu progreso y energía de forma real.'
}];
export function WhatYouGet() {
  return <SectionWrapper className="bg-brand-cream" data-id="element-130">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-131">
        <div className="text-center mb-16" data-id="element-132">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-dark mb-4" data-id="element-133">
            Lo que recibirás hoy mismo
          </h2>
          <p className="text-xl text-gray-600" data-id="element-134">
            Todo lo que necesitas para tu transformación de 48 horas.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16" data-id="element-135">
          {deliverables.map((item, index) => <div key={index} className={`bg-white rounded-2xl p-6 shadow-sm border border-gray-100 flex items-start gap-4 ${index === deliverables.length - 1 ? 'md:col-span-2 md:max-w-xl md:mx-auto w-full' : ''}`} data-id="element-136">
              <CheckCircle2 className="w-7 h-7 text-brand-teal flex-shrink-0 mt-1" data-id="element-137" />
              <div data-id="element-138">
                <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-139">
                  {item.title}
                </h3>
                <p className="text-gray-600" data-id="element-140">{item.description}</p>
              </div>
            </div>)}
        </div>

        <CTAButton data-id="element-141" />
      </div>
    </SectionWrapper>;
}